import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCropComponent } from "./med-icon-crop.component";

@NgModule({
  declarations: [
    MedIconCropComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCropComponent,
  ],
})
export class MedIconCropModule { }
